module.exports = __webpack_public_path__ + "img/about-index.88231270.jpg";